import { countries as countries_es } from "../constants/nameCountry.js";
import { countries_en } from "../constants/nameCountry.js";
import { getMonthText } from "./getMonthText.js";

/**
 *
 * @param {Object} data Object holding legend data
 * @param {string} language Language
 * @returns Array with updated names of countries and/or legend text
 */
export function transformNameCountries(data, language) {
  let transformed = [];
  let newData = {};
  let index = -1;

  const listcountries = Object.keys(
    language === "en" ? countries_en : countries_es
  );
  const newFecha = data.dates.map((e, i) => getMonthText(e, "es", false));

  for (const i in data) {
    if (language === "en") {
      transformed.push(
        countries_en[listcountries.find((element) => element === i)]
      );
    } else {
      transformed.push(
        countries_es[listcountries.find((element) => element === i)]
      );
    }
  }

  for (const i in data) {
    index++;
    newData[transformed[index]] = data[i];
  }
  newData["dates"] = newFecha;
  return newData;
}
